import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { createAgreement } from '~/src/features/full-buy/store/actions/createAgreement';

/**
 * Экран диспатчит создание договора
 */
export const CreateAgreementScreen = (): JSX.Element => {
    const analytics = useAnalytics();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(createAgreement(analytics));
    }, []);

    return <></>;
};
